import api, { TipoOptions } from './api';

export interface Status {
  id: string;
  nome: string;
  codigo: number;
}

export interface Tipo {
  id: string;
  nome: string;
  codigo: number;
}


export const getAllStatusRequisicaoCompraSeq = () =>
  api.get<Status[]>('status/getAllStatusRequisicaoCompraSeq');


export const getAllStatusRequisicaoCompraSeqOptions = () =>
  getAllStatusRequisicaoCompraSeq().then(statusModulo =>
    (statusModulo || []).map(t => ({ text: t.nome, value: t.id.toString() })),
  );



export const getAllTipoExecutadoAnoMes = () => api.get<Status[]>('status/getAllTipoExecutadoAnoMes');

export const getAllTipoExecutadoAnoMesOptions = () => {
  return getAllTipoExecutadoAnoMes().then(Tipo =>
    (Tipo || []).map(t => ({ text: t.nome, value: t.id.toString() } as TipoOptions)),
  );
}


export const getAllClassificaoRfa = () => api.get<Status[]>('status/getAllClassificaoRfa');

export const getAllClassificaoRfaOptions = () => {
  return getAllClassificaoRfa().then(Tipo =>
    (Tipo || []).map(t => ({ text: t.nome, value: t.id.toString() } as TipoOptions)),
  );
}
